import RoutingMoshkelat from "./Moshkelat/RoutingMoshkelat";
import RoutingPost from "./Post/RoutingPost";
import RoutingChat from "./Chat/RoutingChat";
import RoutingFriend from "./Friend/RoutingFriend";
import RoutingMosavabat from "./Mosavabat/RoutingMosavabat";
import RoutingTopic from "./Topic/RoutingTopic";


class RoutingCms {

    constructor() {
        this.routes=[ ];

        let rm1=new RoutingMoshkelat();
        this.routes = this.routes.concat(rm1.get());

        let rp3=new RoutingPost();
        this.routes = this.routes.concat(rp3.get());

        let rc1=new RoutingChat();
        this.routes = this.routes.concat(rc1.get());

        let rf1=new RoutingFriend();
        this.routes = this.routes.concat(rf1.get());

        let rms1=new RoutingMosavabat();
        this.routes = this.routes.concat(rms1.get());

        let rt1=new RoutingTopic();
        this.routes = this.routes.concat(rt1.get());

    }

    get(){
        return this.routes;
    }
}

export default RoutingCms;
